import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingNavigationBarClickEvent implements GATrackingEvent {

  constructor(private navigationItemName: string) {

  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.NavigationBarClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      label: this.navigationItemName,
      gtmCustom: {
        category: GaTrackingEventName.Navigation
      }
    };
  }
}
